import { QueryObserverOptions, useQuery } from 'react-query';

import { useDlVaultContract } from 'clients/contracts/hooks';
import { DEFAULT_REFETCH_INTERVAL_MS } from 'constants/defaultRefetchInterval';
import FunctionKey from 'constants/functionKey';

import getHKTPrice, { GetHKTPriceInput, GetHKTPriceOutput } from '.';

type Options = QueryObserverOptions<
  GetHKTPriceOutput,
  Error,
  GetHKTPriceOutput,
  GetHKTPriceOutput,
  [FunctionKey.GET_HKT_PRICE, string]
>;

const useGetHKTPrice = (
  { accountAddress }: Omit<GetHKTPriceInput, 'dlVaultContract'>,
  options?: Options,
) => {
  const dlVaultContract = useDlVaultContract();

  return useQuery(
    [FunctionKey.GET_HKT_PRICE, accountAddress],
    () =>
      getHKTPrice({
        dlVaultContract,
        accountAddress,
      }),
    {
      refetchInterval: DEFAULT_REFETCH_INTERVAL_MS,
      ...options,
    },
  );
};

export default useGetHKTPrice;
